<template>
  <div class="d-flex">
    <div class="align-self-center">
      <b-form class="login row" @submit.prevent="handleSubmit">
          <div class="col-md-3"></div>
          <div class="col-md-6">
            <div class="formLogin">
              <img id="imgLogin" class="mx-auto d-block img-fluid" :src="'/img/'+this.partner.code+'/logo_blanc.png'"/>
              <div class="pt-5 pb-5">
                <b-form-group id="username-group" label="Identifiant" label-for="username">
                    <b-form-input id="username" v-model="username" type="text" required placeholder="Nom d'utilisateur" :disabled="loading"></b-form-input>
                </b-form-group>
                <b-form-group id="password-group" label="Mot de passe" label-for="password">
                    <b-form-input id="password" v-model="password" :type="viewPassword?'text':'password'" required placeholder="Mot de passe" :disabled="loading"></b-form-input>
                    <span class="material-icons" @click="viewPassword=!viewPassword" style="position:absolute;top:5px;right:5px;cursor:pointer">visibility{{viewPassword?"_off":""}}</span>
                </b-form-group>
                <br/>
                <b-button type="submit" class="btn btn-block btn-outline-gold mt-3 mb-3 border-2 bold"><span v-if="connexion">Connexion ...</span><span v-if="!connexion">Se connecter</span></b-button>
                <p class="text-center"><b-link id="mdpLogin" href="javascript:void(0)" @click="modalmdp">Mot de passe oublié ?</b-link></p>
              </div>
            </div>
            <div class="cookies_bar row">
              <div class="col-md-6 text-left">
                <a href="javascript:void(0)" @click="$bvModal.show('modal-cgu')"> {{$t("Conditions Générales de Vente")}}</a>
              </div>
              <div class="col-md-6 text-right">
                <a href="javascript:void(0)" @click="$bvModal.show('modal-cookies')"> {{$t("Politique de cookies")}}</a>
              </div>
            </div>
          </div>
          <div class="col-md-3"></div>
      </b-form>
    </div>
    <b-modal id="modal-mdp" title="Votre demande de réinitialisation" hide-footer>
      <p class="my-4">Afin de récupérer vos identifiants, Merci de remplir votre nom d'utilisateur.</p>
      <b-form-group id="username-group" label="Identifiant" label-for="username">
          <b-form-input id="username" v-model="username" type="text" required placeholder="Nom d'utilisateur" :disabled="loading"></b-form-input>
      </b-form-group>
      <b-button type="button" @click="resetmdp" class="btn btn-block btn-outline-gold mt-3 mb-3 border-2 bold"><span v-if="loading">Demande en cours ...</span><span v-if="!loading">Recevoir mon lien de réinitialisation</span></b-button>
    </b-modal>
    <b-modal id="modal-mdp-ok" title="Votre demande de réinitialisation" hide-footer>
      <p class="my-4">Si votre compte existe est actif, la demande est envoyée et vous allez recevoir un mail.</p>
      <b-button type="button" @click="closemdp" class="btn btn-block btn-outline-gold mt-3 mb-3 border-2 bold azure">Fermer</b-button>
    </b-modal>
    <!--<p class="cookies_bar" v-if="cb_accepted===false">Ce site utilise des cookies, petits fichiers enregistrés sur votre terminal lors de votre visite sur le site. Vous pouvez accepter ou refuser leur dépôt. En poursuivant votre visite, vous acceptez l'utilisation de cookies pour mesurer notre audience, vous proposer des contenus et fonctionnalités personnalisés. <a href="javascript:void(0)" @click="cb_accept" class="btn btn-default btn-sm">Oui, j'accepte</a> <a :href="this.partner.cookies_url" target="_blank" class="btn btn-default btn-sm">En savoir plus</a>  </p>-->
  </div>
</template>

<script>
  import axios from "axios";
  export default {
    data() {
      return {
        username: '',
        password: '',
        connexion : false,
        token : '',
        usid : '',
        cb_accepted:false,
        viewPassword:false
      }
    },
    created () {
      if(localStorage.getItem('user') && this.$route.path.indexOf("/logout")<0){
        this.$router.push('/');
      }
      else{
        if(this.$route.path.indexOf("/logout")>=0){
          this.logout();
          window.location.href='/login';
        }
        if(!this.partner.url_mdp)this.maj_partner(this.$route);
        // get return url from route parameters or default to '/'
        this.returnUrl = this.$route.query.returnUrl || '/';
      }
    },
    mounted () {
      this.get_partner(this.$route);
      this.token = this.$route.params.token;
      this.usid = this.$route.params.usid;
      if(typeof(this.token)!="undefined" && this.token!=""){
        var p=this;
        p.loading = true;
        let formData = new FormData();
        formData.append('token', this.token);
        formData.append('usid', this.usid);
        formData.append('host', window.location.hostname);
        this.connexion = true;
        axios.post(this.$apiUrl+'login',formData,{headers: {'Content-Type': 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2)}}).then(function(response){
          if (response.data.error) {
            p.show_alert("warning",response.data.error);
          } else {
            if (response.data.datas && response.data.count>0) {
                var user=response.data.datas;
                p.set_current_user(user);
                if(user.infos_cli.menu.length<=3){
                  p.returnUrl=user.infos_cli.menu[0].routeUrl;
                }
                p.$router.push(p.returnUrl).catch(error => {});
            } else {
              p.infosModal("warning",response.data.error);
            }
          }
          p.connexion = false;
          p.loading = false;
        }).catch(function(error){
          p.connexion = false;
          p.loading = false;
        });
      }
    },
    methods: {
      resetmdp(){
        var p=this;
        if(p.loading)return false;
        p.loading=true;
        let formData = new FormData();
        formData.append('username', username);
        formData.append('host', window.location.hostname);
        axios.post(this.$apiUrl+'user/passReset/'+p.username,formData,{headers: {'Content-Type': 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2)}}).then(function(response){
          p.loading=false;
          if (response.data.error) {
            p.show_alert("warning",response.data.error.join(', '));
          }
          else {
            p.$bvModal.show("modal-mdp-ok");
          }
        });
      },
      modalmdp(){
        if(this.username=="")this.$bvModal.show("modal-mdp");
        else{
          this.resetmdp();
        }
      },
      closemdp(){
        this.$bvModal.hide("modal-mdp-ok");
      },
      cb_not_accepted(){
        if(is_cb_accepted())this.cb_accepted=false;
        else this.cb_accepted=true;
      },
      cb_accept(){
        this.set_cb_accepted();
        this.cb_accepted=true;
      },
      handleSubmit (e) {
        this.logout();

        this.submitted = true;
        const { username, password } = this;

        // stop here if form is invalid
        if (!(username && password)) {
            return;
        }

        var p=this;
        if(p.loading)return false;
        p.loading = true;
        let formData = new FormData();
        formData.append('username', username);
        formData.append('password', password);
        formData.append('host', window.location.hostname);
        this.connexion = true;
        axios.post(this.$apiUrl+'login',formData,{headers: {'Content-Type': 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2)}}).then(function(response){
          if (response.data.error) {
            p.show_alert("warning",response.data.error);
          } else {
            if (response.data.datas && response.data.count>0) {
                var user=response.data.datas;
                p.set_current_user(user);
                if(user.infos_cli.menu.length<=3){
                  p.returnUrl=user.infos_cli.menu[0].routeUrl;
                }
                p.$router.push(p.returnUrl).catch(error => {});
                p.get_infos_cli();
            } else {
              p.infosModal("warning",response.data.error);
            }
          }
          p.connexion = false;
          p.loading = false;
        }).catch(function(error){
          p.show_alert("warning","Le service api-fw.ooftop.fr n'est pas accessible.");
          p.connexion = false;
          p.loading = false;
        });
      }
    },
  }
</script>